import { render, staticRenderFns } from "./collegeRuleTool.vue?vue&type=template&id=2c270d1a&scoped=true&"
import script from "./collegeRuleTool.vue?vue&type=script&lang=js&"
export * from "./collegeRuleTool.vue?vue&type=script&lang=js&"
import style0 from "./collegeRuleTool.vue?vue&type=style&index=0&id=2c270d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c270d1a",
  null
  
)

export default component.exports